import { useFormContext, Controller } from 'react-hook-form';
import { Autocomplete, AutocompleteItem, AutocompleteProps } from '@nextui-org/react';
import { cn } from '@PorkyCol/theme';

interface Props extends AutocompleteProps {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
  onChangeCustom?: any;
  options: { value: string; label: string }[];
}

export default function RHFAutocomplete2({
  name,
  label,
  helperText,
  onChangeCustom,
  ...other
}: Omit<Props, 'children'>) {
  const { control, setValue } = useFormContext();
  if (!other.options.length) {
    return null;
  }

  const handleChange = (newValue: any) => {
    setValue(name, newValue, { shouldValidate: true });
    onChangeCustom?.(newValue);
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          variant="bordered"
          label={label}
          errorMessage={error ? error?.message : helperText}
          isInvalid={!!error}
          selectedKey={field.value}
          defaultItems={other.options}
          className="w-full"
          inputProps={{
            classNames: {
              label: cn('!text-gray-400', {
                'text-red-500': !!error,
              }),
            },
          }}
          onSelectionChange={handleChange}
        >
          {(item) => <AutocompleteItem key={item.value}>{item.label}</AutocompleteItem>}
        </Autocomplete>
      )}
    />
  );
}
